import {FormattedMessage, useIntl} from 'react-intl'
import useNavigation from '../../../hooks/use-navigation'
import React, {useCallback} from 'react'
import {productUrlBuilder} from '../../../utils/url'
import {Button} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import {EditIcon} from '../../icons'

/**
 * Product Tile CTA for product tile `wishlist` variant displaying product set
 *   - on click navigates to the PSDP
 *
 * @param {object} product
 * @param {object} rest
 */
const CustomizeCTA = ({product, ...rest}) => {
    const {locale} = useIntl()
    const navigate = useNavigation()
    const onClick = useCallback(
        (e) => {
            e.stopPropagation?.()
            navigate(productUrlBuilder(product, locale))
        },
        [locale, navigate, product]
    )
    return (
        <Button
            onClick={onClick}
            width="full"
            variant="solid"
            iconSpacing={2}
            rightIcon={<EditIcon boxSize={4} />}
            pointerEvents="auto"
            {...rest}
        >
            <FormattedMessage id="product_tile.customize" defaultMessage="Customise" />
        </Button>
    )
}

CustomizeCTA.propTypes = {
    product: PropTypes.object,
    onClick: PropTypes.func
}

export default CustomizeCTA
